// Constants - action names
export const SHOW_MODAL = 'pv-kultu/modal/SHOW_MODAL';
export const HIDE_MODAL = 'pv-kultu/modal/HIDE_MODAL';

// Helpers
// --

// Initial state
const initialState = {
  modalType: undefined,
  modalProps: {}
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_MODAL:
      return Object.assign({}, state, {
        modalType: action.modalType,
        modalProps: action.modalProps
      });
    case HIDE_MODAL:
      return initialState;
    default:
      return state;
  }
}

// Actions
export function showModal(modalType, modalProps) {
  return {type: SHOW_MODAL, modalType, modalProps};
}

export function hideModal() {
  return {type: HIDE_MODAL};
}


// WEBPACK FOOTER //
// ./src/ducks/modal.js